import React from 'react';
import './style.css';

function VerificationButton(props) {
  const {
    title = 'title', onClick = () => {}, disabled, enable,
  } = props;
  return (
    <div className="btn-div">
      <button
        type="button"
        className={`buttonStyle ${
          enable ? 'buttonStyleEnable' : 'buttonStyleDisabled'
        }`}
        disabled={!enable}
        onClick={() => {
          if (enable) {
            onClick();
          } else if (disabled) {
            onClick();
          }
        }}
      >
        {title}
      </button>
    </div>
  );
}

export default VerificationButton;
